import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faPen } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'

const estadoInicial = {
    name: '',
    
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
    tipoPesquisa: 0,
}

class Relatorios extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
    }

    filterItems = (item) => {
        return true
    }

    render() {

        return (
            <div className='page'>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                {!this.state.loading &&
                    <div>
                        <section>
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Relatórios</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                    </div>
                }
                <Footer selected="RELATORIOS" />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Relatorios)
